import Util from '../../util/util'
import _ from 'lodash'

let _log = Util.logger;
let _cookie = Util.cookies;

// ------------------------------------
// Constants
// ------------------------------------
export const CUSTOMERORDERDETAILS = 'CUSTOMERORDERDETAILS'
export const LOGINCREDENTIALS = 'LOGINCREDENTIALS'
export const ERROR_GETCREDENTIALS = 'ERROR_GETCREDENTIALS'
export const ERROR_CLEARCODE = 'ERROR_CLEARCODE'
export const PROCESSINGMODAL = 'PROCESSINGMODAL'
export const SHOW_VIEWER_MODAL = 'SHOW_VIEWER_MODAL'
export const HIDE_VIEWER_MODAL = 'HIDE_VIEWER_MODAL'

let reduxstates = {
  'errorsReducer': errorsReducer,
  'loginCredentialsReducer': loginCredentialsReducer,
  'customerOrderDetailsReducer': customerOrderDetailsReducer,
  'processingModalReducer' : processingModalReducer,
  'viewerModalReducer' : viewerModalReducer,
  "ERROR_GETCREDENTIALS": ERROR_GETCREDENTIALS,
  "SHOW_VIEWER_MODAL": SHOW_VIEWER_MODAL,
  "HIDE_VIEWER_MODAL": HIDE_VIEWER_MODAL,
  'logincredentials' : LOGINCREDENTIALS,
  'customerorderdetails' : CUSTOMERORDERDETAILS,
  'processingmodal': PROCESSINGMODAL
}

// ------------------------------------
// Reducer
// ------------------------------------
export function errorsReducer (state = {}, action) {
  if (_.startsWith(action.type, "ERROR_")) {
    var o = Object.assign({}, state);
    if (!o.messages || o.messages.length < 1) {
      o.messages = [];
    }


    if (action.type === ERROR_GETCREDENTIALS) {
      var message = Object.assign({}, action.payload);
      message.type = "errorPage";
      o.messages.push(message);
    } else if (action.type === ERROR_CLEARCODE) {
      _.remove(o.messages, m => m.code === action.payload)
    }

    return o;
  }
  return state;
}

export function loginCredentialsReducer (state = {}, action) {
  return (action.type === LOGINCREDENTIALS)
    ? action.payload
    : state
}

export function customerOrderDetailsReducer (state = {}, action) {
  return action.type === CUSTOMERORDERDETAILS
    ? action.payload
    : state
}

export function processingModalReducer (state = {}, action) {
  return action.type === PROCESSINGMODAL
    ? action.payload
    : state
}

export function viewerModalReducer (state = {file: null, name: "", isVisible: false}, action) {
  if (action.type !== SHOW_VIEWER_MODAL && action.type !== HIDE_VIEWER_MODAL) return state;

  if (action.type === SHOW_VIEWER_MODAL) {
    action.payload.isVisible = true;
  } else {
    action.payload.isVisible = false;
  }

  return action.payload;
}

export default reduxstates



// WEBPACK FOOTER //
// ./src/store/reduxstates/states.js